"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = require("react");

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal); // eslint-disable-next-line max-statements


  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);
    _this.modalWrapper = document.createElement('div');
    _this.modalWrapper.className = 'modal__wrapper';
    _this.modalContainer = document.createElement('div');
    _this.modalContainer.className = 'modal__container'; // eslint-disable-next-line complexity

    _this.modalContainer.onmousedown = function (event) {
      if (event.target.classList.contains('modal__container')) {
        _this.props.onOverlayClick(event);
      }
    };

    _this.modalContent = document.createElement('div');
    var modalContentSize = _this.props.size ? "modal__content--".concat(_this.props.size) : '';
    _this.modalContent.className = "modal__content ".concat(modalContentSize, " ").concat(_this.props.optionalClassName);
    _this.modalOverlay = document.createElement('div');
    _this.modalOverlay.className = 'modal__overlay';

    if (!props.hasOverlay) {
      _this.modalOverlay.className = 'modal__overlay modal__overlay--no-background';
    }

    _this.modalWrapper.appendChild(_this.modalContainer);

    _this.modalContainer.appendChild(_this.modalContent);

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.elementToAttachTo.appendChild(this.modalWrapper);
      this.props.elementToAttachTo.appendChild(this.modalOverlay);
      document.body.style.overflow = 'hidden';
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.elementToAttachTo.removeChild(this.modalWrapper);
      this.props.elementToAttachTo.removeChild(this.modalOverlay);
      document.body.style.overflow = '';
    }
  }, {
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        (0, _reactDom.createPortal)(this.props.children, this.modalContent)
      );
    }
  }]);

  return Modal;
}(_react.Component);

exports.Modal = Modal;
Modal.propTypes = {
  children: _propTypes["default"].node.isRequired,
  onOverlayClick: _propTypes["default"].func.isRequired,
  elementToAttachTo: _propTypes["default"].instanceOf(Element),
  hasOverlay: _propTypes["default"].bool,
  optionalClassName: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'large'])
};
Modal.defaultProps = {
  elementToAttachTo: document.body,
  hasOverlay: true,
  optionalClassName: '',
  size: null
};